import { CompetitionBoard, ICompetitionBoard } from '@sky-it-livedata/livedata-sports-design-system';

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { CompetitionBoardQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<CompetitionBoardQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<CompetitionBoardQuery>): ICompetitionBoard => {
  return transformer(props);
}

const CompetitionBoardWidget = ({
  props,
  ...rest
}: WidgetContext<ICompetitionBoard>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <CompetitionBoard {...props} />
    </div>
  );
}

export default CompetitionBoardWidget;